import { render, staticRenderFns } from "./dispatch_rule_list.vue?vue&type=template&id=2be293cb&scoped=true"
import script from "./dispatch_rule_list.vue?vue&type=script&lang=js"
export * from "./dispatch_rule_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be293cb",
  null
  
)

export default component.exports